import { theme } from "@tm/utility/global";
import styled, { css, keyframes } from "styled-components";

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

export const CarouselPersuasionStyle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 328px;
`;

export const CarouselItemStyle = styled.div<{ isAnimating: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: 100%;
  font-size: 16px;
  font-weight: 700;
  color: ${theme.whiteText};
  line-height: 20px;

  picture,
  img {
    display: block;
    flex-shrink: 0;
  }

  picture,
  img {
    display: block;
    flex-shrink: 0;
  }

  ${({ isAnimating }) =>
    isAnimating &&
    css`
      animation: ${fadeIn} 0.1s ease-in;
    `}

  opacity: ${({ isAnimating }) => (isAnimating ? 1 : 0)};
  transition: opacity 0.1s ease-out;
`;

export const CarouselIconStyle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 20px;
`;

export const CarouselTextStyle = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 20px;
`;

export const ImageContainer = styled(CarouselIconStyle)`
  cursor: pointer;
`;
